
import Vue from 'vue';
import { Label, LabelState } from '@/model';
import labels from '@/store/labels';
import { notEmpty } from '@/util/array-util';
import LabelWithSuggestionIcons from '@/components/LabelWithSuggestionIcons.vue';

export default Vue.extend({
  name: 'LabelPickerAdvancedDocumentLabels',
  components: {
    LabelWithSuggestionIcons,
  },
  props: {
    value: { type: Array as () => number[], required: true },
    isBusy: { type: Boolean, default: false },
  },
  computed: {
    labels(): (Label & LabelState)[] | undefined {
      return this.value
        .map((id) => labels.getters.lookup.get(id))
        .filter(notEmpty)
        .map((l) => ({ ...l, isDocumentLabel: true }));
    },
  },
});
